import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams , ModalController} from 'ionic-angular';
import { MarketplaceProvider } from '../../providers/marketplace/marketplace';
import { Storage } from '@ionic/storage';
import { ToastProvider } from '../../providers/toast/toast';
import { MarketplacereviewmodalPage } from'../marketplacereviewmodal/marketplacereviewmodal';
import { TranslateService } from '@ngx-translate/core';


/**
 * Generated class for the SingleMarketPlacePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-single-market-place',
  templateUrl: 'single-market-place.html',
})
export class SingleMarketPlacePage {
  singleItem: any;
  item: any;
  categoryName:any
  uuid: any;
  user_tenant = false;
  categoryuuid: any;
  marketuuid: any;
  name: any;
  images: any;
  description: any;
  seller_address: any;
  seller_name: any;
  seller_phone: any;
  price: any;
  percent_off: any;
  clicked: any;
  id: any;
  societyuuid: any;
  feedback: '';
  rating = "0";
  userList:any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private translate: TranslateService,
    private modalCtrl: ModalController,
    private marketplaceprovider: MarketplaceProvider,
    private toast: ToastProvider,
    private storage: Storage) {
    this.storage.get("loginDetails").then(val => {
      if (val.tenant) {
        this.user_tenant = val.tenant;
      }
    });

    this.userList = this.navParams.get("userList");
    console.log(this.userList,"Singlepage")
    this.societyuuid = this.navParams.get("societyuuid");
    this.marketuuid = this.navParams.get("marketuuid");
    this.categoryuuid = this.navParams.get("categoryuuid");
    this.uuid = this.navParams.get("itemid");
    this.singleItem = this.navParams.get("itemSingle");
    this.categoryName =  this.navParams.get("categoryName");
    console.log(this.categoryName)

    this.marketplaceprovider.getSingleItem(this.marketuuid, this.categoryuuid, this.uuid).then(val => {
      console.log(val)
      this.item = val['data'];
      this.name = this.item['name'];
      this.images = this.item['images'];
      this.description = this.item['description'];
      this.seller_address = this.item['seller_address'];
      this.seller_name = this.item['seller_name'];
      this.seller_phone = this.item['seller_phone'];
      this.price = this.item['price'];
      this.percent_off = this.item['price_off'];
      this.clicked = this.item['clicked'];
      this.id = this.item['uuid'];
      this.rating = this.item['rating']

    });
  }


  starClicked(num: number) {
    num++;
    this.rating = num.toString();
    console.log(this.rating);
  }

  nonStarClicked(num: number) {
    let temp = +this.rating;
    temp = temp + num + 1;
    this.rating = temp.toString();
    console.log(this.rating);
  }

  getRating(rating: string) {
    return Array(+rating);
  }

  getNonRating(rating: string) {
    return Array(5 - (+rating));
  }

  reviewModal(page){
    let modal =  this.modalCtrl.create(MarketplacereviewmodalPage, {
      parentPageNav: this.navCtrl,
      societyUUID :this.societyuuid,
      marketUUID : this.marketuuid,
      ID: this.id,
      userList : this.userList,
      report_page : page
      
    });
    modal.present();
  }


  onContactSeller(){
    this.marketplaceprovider.contactSeller(this.societyuuid,this.uuid).then(val => {
      this.toast.presentToast(val.message);
      console.log(val)

  })
}


  ionViewDidLoad() {
    console.log('ionViewDidLoad SingleMarketPlacePage');
  }


}



// WEBPACK FOOTER //
// ./src/pages/single-market-place/single-market-place.ts